import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="ntb-copilot-footer">
      <div className="ntb-copilot-footer-content">
        <div className="ntb-copilot-footer-nav">
          <Link to="/about" className="ntb-copilot-footer-link">About</Link>
          <Link to="/support" className="ntb-copilot-footer-link">Support</Link>
          <Link to="/pricing" className="ntb-copilot-footer-link">Pricing</Link>
          <Link to="/terms" className="ntb-copilot-footer-link">Terms of Service</Link>
          <Link to="/privacy" className="ntb-copilot-footer-link">Privacy Policy</Link>
        </div>
        <div className="ntb-copilot-copyright">
          &copy; {currentYear} NanoTradingCopilot. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
